import React from "react";
import { DisabledPrompt, useRoute } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from "components/shared";
import { PrimaryButton, SecondaryButton, UITextInput } from "components/ui";
import { FormButtonRow } from "components/shared/containers/FormContainer";

import "./styles.css";
import "./mobile.css";

export default function ForgotPasswordPage(props) {
  const navigate = useRoute();
  
  return (
    <PageContainer className="forgot-password-page">
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Forgot Password" />
          <div className="flex-container flex-vertical required-fields-container">
            <b>Required fields:</b>
            <p>User ID, Email Address, and one of the Optional fields</p>
          </div>
          <FormContainer className="small-form-width ">
            <FormRowView text="User ID">
              <UITextInput />
            </FormRowView>
            <FormRowView text="Last Name (Optional)">
              <UITextInput />
            </FormRowView>
            <FormRowView text="Email Address">
              <UITextInput />
            </FormRowView>
            <FormRowView text="Mobile Phone (Optional)">
              <UITextInput />
            </FormRowView>
            <FormButtonRow>
                <SecondaryButton text="Cancel" onClick={()=> navigate("/login")}/>
              <DisabledPrompt>
                <PrimaryButton text="Submit" />
              </DisabledPrompt>
            </FormButtonRow>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
